import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import HowItWorksModal from "@via/components/how-it-works/how-it-works-modal";
import { classNames } from "@via/utils/helpers.tsx";

type HowItWorksHelpProps = {
  title: React.ReactNode;
  children: React.ReactNode;
  buttonText?: string;
  buttonClassName?: string;
};

export default function HowItWorksHelp({
  title,
  children,
  buttonText = "Quick Guide",
  buttonClassName = "",
}: HowItWorksHelpProps): JSX.Element {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={classNames(
          "shrink-0 inline-flex items-center gap-x-1.5 rounded-md bg-indigo-50 px-3 py-2 text-sm font-semibold text-indigo-700 shadow-sm ring-1 ring-inset ring-indigo-200 hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-indigo-600",
          buttonClassName
        )}
        onClick={() => setOpen(true)}>
        <InformationCircleIcon className="h-5 w-5" />
        {buttonText}
      </button>

      <HowItWorksModal open={open} setOpen={setOpen} title={title}>
        {children}
      </HowItWorksModal>
    </>
  );
}
